import React, { Component } from "react";

import Clientcard from "../elements/Clientcard";
import classNames from "classnames";
import db from "../../api/db";
import CircularProgress from "@material-ui/core/CircularProgress";

class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      string: "",
      postalcode: "",
      results: [],
      client: "",
      loading: true
    };
    this.handleChange = this.handleChange.bind(this);
    this.setClear = this.setClear.bind(this);
  }

  componentDidMount() {
    const id = this.props.match.params.id ? this.props.match.params.id : "";
    this.setState({
      client: id
    });
    this.search_input.focus();
    this.searchQuery(this.state.string);
  }

  handleChange(event) {
    let string = this.state.string;
    let postal = this.state.postalcode;

    if (event.target.name === "string") {
      string = event.target.value;
    } else if (event.target.name === "postalcode") {
      postal = event.target.value;
    }

    this.setState(
      {
        string: string,
        postalcode: postal,
        client: ""
      },
      () => this.searchQuery(string, postal)
    );
  }

  searchQuery(string = this.state.string, postal = this.state.postalcode) {
    let query = {};
    if (postal.length === 4) {
      query = {
        postalcodes: postal
      };
    } else {
      query = {
        name: string
      };
    }
    this.setState({
      loading: true
    });

    db.query("client", query).then(response => {
      this.setState({
        results: response.data,
        loading: false
      });
    });
  }

  searchPostalQuery(string = this.state.postalcode) {
    let query = {};

    this.setState({
      loading: true
    });

    if (string.length === 4) {
      query = {
        postalcodes: string
      };

      db.query("client", query).then(response => {
        this.setState({
          results: response.data,
          loading: false
        });
      });
    }
  }

  setClear() {
    this.setState({
      client: ""
    });
    this.searchQuery();
    this.props.history.push("/client");
  }

  setClient(id) {
    this.setState({
      client: id
    });
    this.props.history.push(`/client/${id}`);
  }

  createNew() {
    this.setState({
      client: "new"
    });
    this.props.history.push("/client/new");
  }

  render() {
    let clients = this.state.results.map((item, i) => (
      <div
        key={i}
        data-id={item.id}
        onClick={e => this.setClient(item.id)}
        className={classNames("item", {
          active: this.state.client === item.id
        })}
      >
        <div className="t2">{item.name}</div>
      </div>
    ));

    return (
      <div className="main-container">
        <div className="primary-content">
          <div className="grid-x">
            <div className="medium-3 cell">
              <div className="sidebar-right listing">
                <button
                  className="float-right button link black"
                  onClick={e => this.createNew()}
                >
                  Opprett kunde
                </button>
                <div className="heading">Velg kunde</div>
                <label>
                  <input
                    className="search-input"
                    placeholder="Søk medie etter navn"
                    name="string"
                    type="text"
                    value={this.state.string}
                    onChange={this.handleChange}
                    ref={input => {
                      this.search_input = input;
                    }}
                  />
                </label>
                <label>
                  <input
                    className="search-input"
                    placeholder="Søk medie etter postnummer"
                    name="postalcode"
                    type="text"
                    value={this.state.postalcode}
                    onChange={this.handleChange}
                    ref={input => {
                      this.search_postalcode = input;
                    }}
                  />
                </label>
                {this.state.loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <div className="list">{clients}</div>
                )}
              </div>
            </div>
            <div className="medium-7 cell">
              {this.state.client ? (
                <Clientcard client={this.state.client} clear={this.setClear} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Client;
